export default __webpack_public_path__ + "static/media/wave-curly-14.8c0d6484.svg";